import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { MechanismSection } from './components/MechanismSection';
import { ProductSection } from './components/ProductSection';
import { WhoItsFor } from './components/WhoItsFor';
import { TransformationSection } from './components/TransformationSection';
import { PricingCTA } from './components/PricingCTA';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen bg-white font-sans text-[#2D2A26]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedSolutions data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <ProductSection data-id="element-5" />
      <WhoItsFor data-id="element-6" />
      <TransformationSection data-id="element-7" />
      <PricingCTA data-id="element-8" />

      <footer className="bg-[#2D2A26] text-white py-8 text-center text-sm opacity-90" data-id="element-9">
        <p data-id="element-10">
          © {new Date().getFullYear()} Casa Sin Olor. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}